
module.exports = {
  getQueryParams: function(url, name) {
    const result = {}
    const reg = /[?&][^?&#]+=[^?&#]+/g
    const queryList = url.match(reg) || []
    for (let i = 0; i < queryList.length; i++) {
      const item = queryList[i]
      const temp = item.substring(1).split('=')
      const key = decodeURIComponent(temp[0])
      const value = decodeURIComponent(temp[1])
      result[key] = value
    }
    return name ? result[name] : result
  },
  setQueryParams: function(url, params, options = {}) {
    options = Object.assign({
      ignoreOldParams: false, // 忽略url中的queryParams
      ignoreFalse: false, // 忽略parmas中的布尔假值
      ignoreUndefined: false, // 忽略parmas中的undefined值
      encode: true // 是否编码
    }, options)
    if (!options.ignoreOldParams) {
      const originParams = this.getQueryParams(url)
      params = Object.assign(originParams, params)
    }
    url = url.split('?')[0]
    const paramsKeys = Object.keys(params)
    for (let i = 0; i < paramsKeys.length; i++) {
      const key = paramsKeys[i]
      const value = params[key]
      if (options.ignoreFalse && !value) continue
      if (options.ignoreUndefined && value === undefined) continue

      if (i === 0) url += '?'
      if (options.encode) {
        url += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      } else {
        url += `${key}=${value}`
      }
      if (i !== paramsKeys.length - 1) url += '&'
    }
    return url
  },
  loadJSON: function (path) {
    /** load JSON files */
    if (/\.json$/gi.test(path)) {
      const content = this.callSync(path)
      try {
        return JSON.parse(
          content.replace(/\\u2028/g, '\\\\u2028')
            .replace(/\\u2029/g, '\\\\u2029'))
      } catch (e) {
        console.log('Failed to convert invalid configuration file. path: ' + path)
        return {}
      }
    }
    return {}
  },
  callSync: function (path) {
    const xhr = new XMLHttpRequest()
    let content = ''
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 304 || xhr.status === 202 || xhr.status === 0) {
          content = xhr.responseText
        }
      }
    }
    xhr.open('GET', path + '?_t=' + new Date().valueOf(), false)
    xhr.send()
    return content
  },
  // 打印显示错误
  print: function(tmp) {
    let type = Object.prototype.toString.call(tmp).match(/\[object (\w+?)\]/)
    type = type && type[1]

    if (type === 'Error') return tmp.stack
    if (type === 'Object') return tmp.code || tmp.message || JSON.stringify(tmp) // code、message是wmsvr返回的信息
    if (type === 'Array') return JSON.stringify(tmp)

    return tmp
  }
}



// WEBPACK FOOTER //
// ./src/js/global/utils.js